// src/schemas/api/domains/requests/update-domain-logo.ts
//
// Request schema for DomainsAPI::Logic::Domains::UpdateDomainLogo
// POST /:extid/logo
//
//
// POST — multipart file upload. Extid in path.

import { z } from 'zod';

// TODO: Add request parameters for this endpoint.
// Path params: extid
export const updateDomainLogoRequestSchema = z.object({
  // TODO: fill in from DomainsAPI::Logic::Domains::UpdateDomainLogo raise_concerns / process
});

export type UpdateDomainLogoRequest = z.infer<typeof updateDomainLogoRequestSchema>;
